import Album from './album'
import FormInput from './form_input'
import ThumbnailsCollection from './thumbnails_collection'

export default {
  FormInput,
  Album,
  ThumbnailsCollection
}
